// ─── API Base URL ─────────────────────────────────────────────────────────────
// Local dev: serverless-offline runs on http://localhost:3000
// Production: replace with your AWS API Gateway URL
export const server = `https://vwixpe96b5.execute-api.ap-south-1.amazonaws.com`;
// export const server = `http://localhost:3000`;

// ─── Auth helpers ─────────────────────────────────────────────────────────────
export const getToken    = () => localStorage.getItem("water_admin_token");
export const setToken    = (t) => localStorage.setItem("water_admin_token", t);
export const removeToken = () => localStorage.removeItem("water_admin_token");
export const getUser  = () => { try { return JSON.parse(localStorage.getItem("water_admin_user") || "null"); } catch { return null; } };
export const setUser  = (u) => localStorage.setItem("water_admin_user", JSON.stringify(u));
export const removeUser = () => localStorage.removeItem("water_admin_user");

// ─── Fetch wrapper ────────────────────────────────────────────────────────────
//
// The water backend returns:    { success: bool, message: str, data: any }
// The reference admin expects flat JSON. We unwrap `data` and surface `message`
// on errors so the UI doesn't have to think about it.
//
export async function apiFetch(path, options = {}) {
  const token = getToken();
  const headers = { "Content-Type": "application/json", ...(options.headers || {}) };
  if (token) headers["Authorization"] = `Bearer ${token}`;

  const response = await fetch(`${server}${path}`, { ...options, headers });

  if (response.status === 401) {
    removeToken(); removeUser();
    if (window.location.pathname !== "/") window.location.href = "/";
    return null;
  }

  const json = await response.json().catch(() => ({}));

  if (!response.ok || json.success === false) {
    const msg = json.message || json.error || `Request failed: ${response.status}`;
    throw new Error(msg);
  }

  // Unwrap the standard `data` envelope; fall back to whole body if not present
  return json && typeof json === "object" && "data" in json ? json.data : json;
}

export const api = {
  get:    (path)       => apiFetch(path),
  post:   (path, body) => apiFetch(path, { method: "POST",   body: JSON.stringify(body) }),
  put:    (path, body) => apiFetch(path, { method: "PUT",    body: JSON.stringify(body) }),
  delete: (path)       => apiFetch(path, { method: "DELETE" }),
};
